import "@/App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AITransformation from "@/pages/AITransformation";
import CountryNetherlands from "@/pages/CountryNetherlands";
import CountryGermany from "@/pages/CountryGermany";
import CountrySwitzerland from "@/pages/CountrySwitzerland";
import CountryBelgium from "@/pages/CountryBelgium";
import CountryUK from "@/pages/CountryUK";
import NotFound from "@/pages/NotFound";
import { LanguageProvider } from "@/i18n";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "services", element: <Services /> },
      { path: "industries", element: <Industries /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "ai-transformation", element: <AITransformation /> },
      { path: "countries/netherlands", element: <CountryNetherlands /> },
      { path: "countries/germany", element: <CountryGermany /> },
      { path: "countries/switzerland", element: <CountrySwitzerland /> },
      { path: "countries/belgium", element: <CountryBelgium /> },
      { path: "countries/united-kingdom", element: <CountryUK /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);

export default function App() {
  return (
    <LanguageProvider>
      <RouterProvider router={router} />
    </LanguageProvider>
  );
}
